export const STEP_SLUGS = [
    'choose-niche',
    'choose-banners',
    'choose-selling-plan',
    'sign-up',
    'link-your-store',
    'install-app',
    'subscribe',
    'create-store',
    'additional-services',
    'subscribe-autods',
    'publish',
] as const;

export type StepSlug = (typeof STEP_SLUGS)[number];
